/**
 * Straßenfeld mit Adressvorschlägen — die nächste Adresse zu Dresden zuerst.
 *
 * Ein Tipp auf einen Vorschlag setzt Straße, PLZ und Ort. Wer selbst tippt,
 * behält seinen Text: die Vorschläge sind ein Angebot, kein Zwang. PLZ und Ort
 * werden nur überschrieben, wenn der Vorschlag sie wirklich hat — sonst leerte
 * ein Treffer ohne Postleitzahl ein schon gepflegtes Feld.
 *
 * Die Vorschläge kommen vom eigenen Server (`/adresse/vorschlaege`,
 * `kontor_adresse.py`). Direkt aus dem Browser zu Nominatim ging nie etwas
 * durch: Kontors Content-Security-Policy erlaubt nur die eigene Adresse.
 */
import type { CSSProperties } from "react";
import { MOrtAutocomplete, type Adressteile } from "@vimaana/ui";

export const ADRESS_VORSCHLAG_URL = "/api/kontor/adresse/vorschlaege";

type Props = {
  value: string;
  onChange: (strasse: string) => void;
  /** Mit den Teilen des gewählten Vorschlags — PLZ und Ort nur, wenn vorhanden. */
  onPick?: (teile: Adressteile) => void;
  onBlur?: () => void;
  placeholder?: string;
  inputStyle?: CSSProperties;
  inputClassName?: string;
};

export default function StrassenFeld({ value, onChange, onPick, onBlur, placeholder = "Straße und Hausnummer", inputStyle, inputClassName }: Props) {
  return (
    <MOrtAutocomplete
      value={value}
      onChange={onChange}
      onPick={onPick}
      onBlur={onBlur}
      placeholder={placeholder}
      inputStyle={inputStyle}
      inputClassName={inputClassName}
      vorschlagUrl={ADRESS_VORSCHLAG_URL}
    />
  );
}
